export const OwnerContactsEvent = {
  RequestInfo: 'requestInfo',
  BookViewing: 'bookViewing',
  SelectUserRole: 'selectUserRole',
  MakeOffer: 'makeOffer',
};

export const RequestInfoReason = {
  MakeOffer: 'make offer',
  BookShowing: 'book showing',
};

export const BookViewingCarouselPropsEventType = {
  ActiveIndexChange: 'activeIndexChange',
  SelectItem: 'selectItem',
  ItemsAmountChange: 'itemsAmountChange',
};
